module.exports = __webpack_public_path__ + "b9f8f9d0616b093b86686866e4a1b889.svg";